"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransfersFactory = void 0;
const transactionFactory_1 = require("./transactionFactory");
class TransfersFactory extends transactionFactory_1.TransactionFactory {
}
exports.TransfersFactory = TransfersFactory;
//# sourceMappingURL=transfersFactory.js.map